export default function focusInput(input) {
  if (!input) {
    console.error('No input passed to focusInput');
    return;
  }
  let value = input.val();
  if (value === 'http://') {
    //Do this so the browser doesn't highlight our selected text
    input.focus().val(value);
  } else {
    input.focus();
  }
  //Firefox does not focus at the end of existing text.
  //Move caret to end of set text
  if (value) {
    input[0].selectionStart = value.length;
    input[0].selectionEnd = value.length;
  }
}